module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [(_vm.ultima_revisao) ? _c('ed-alert', {
    staticClass: "text-left",
    attrs: {
      "title": "Última Revisão desse LTCAT",
      "type": "warning"
    }
  }, [_c('span', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [(_vm.ultima_revisao.parent) ? _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.parent.rev) + " (" + _vm._s(_vm.ultima_revisao.parent.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.parent.data, true)) + ") /\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.ultima_revisao.rev) + " (" + _vm._s(_vm.ultima_revisao.descricao) + " em " + _vm._s(_vm.toDate(_vm.ultima_revisao.data, true)) + ")\n\t\t\t\t\t")])])]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bdf2232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/cadastrar.vue
// module id = 1504
// module chunks = 45